import styled from 'styled-components'

export const StyledCanvasViewWrapper = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
`
